import React from "react";

const UnAuth = () => {
  return (
    <main className="main">
      <section className="section !w-auto">
        <h1 className="heading whitespace-nowrap !mb-0">Unauthorized Access</h1>
      </section>
    </main>
  );
};

export default UnAuth;
